// extracted by mini-css-extract-plugin
export default {"container":"AdminAllBlogs_container__IWEvI","content":"AdminAllBlogs_content__Co0-m"};